import { Fancybox } from "@fancyapps/ui";



export const initFancyBox = function() {

    console.log("initFancyBox")

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: [
              "thumbs",
              "close",
            ],
        },
        
      });

      
 
 
 } 